import { CreateFolderAbstractValidator } from './create.folder.abstract.validator';
import { TreeProtectedEntity } from '../../../helpers/types';

export class CreateCompanyFolderActionValidator extends CreateFolderAbstractValidator {
  protected allowTypes = [Constants.Companies.TYPE_COMPANIES_COLLECTION, Constants.Companies.TYPE_COMPANY_FOLDER];
  protected _canPerformAction(record: TreeProtectedEntity): boolean {
    if (record.realNode && record.realNode.id !== record._id) {
      return super._canPerformAction(record.realNode);
    }

    return super._canPerformAction(record);
  }
}
